import { createAction } from "redux-actions";

const menuClicked = createAction(
  "MENU_CLICKED",
  () => ({}),
  // Los tres call sites pasan la key del ítem, no un objeto `{ menu }`, así que
  // esta desestructuración da `undefined` y el evento sale siempre como
  // `menu-clicked-undefined`. Se conserva el comportamiento actual; ver SEG-1525.
  (arg: string | number) => ({
    analytics: {
      eventName: `menu-clicked-${(arg as any).menu}`,
      eventData: {},
    },
  })
);

export { menuClicked };
